var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "utxo_row"
  }, [_vm.txId !== '-' ? _c('span', {
    staticClass: "force-ellipsis"
  }, [_c('router-link', {
    attrs: {
      "to": "/tx/".concat(_vm.txId)
    }
  }, [_vm._v(_vm._s(_vm.txId))])], 1) : _c('p', [_vm._v("-")]), _c('p', {
    staticClass: "redeemed"
  }, [_vm.redeemed ? _c('fa', {
    attrs: {
      "icon": "check-circle"
    }
  }) : _vm._e()], 1), _c('p', [_vm._v(_vm._s(_vm.utxo.locktime))]), _c('p', [_vm._v(_vm._s(_vm.utxo.threshold))]), _c('span', {
    staticClass: "force-ellipsis"
  }, _vm._l(_vm.utxo.addresses, function (_ref, i) {
    var address = _ref.address,
        displayAddress = _ref.displayAddress;
    return _c('router-link', {
      key: i,
      attrs: {
        "to": "/address/X-".concat(address)
      }
    }, [_vm._v(_vm._s(displayAddress))]);
  }), 1), _c('div', {
    staticClass: "type"
  }, [_vm._v(" " + _vm._s(_vm._f("getOutputType")(_vm.utxo.outputType)) + " ")]), _c('div', {
    staticClass: "col_amount"
  }, [_c('p', {
    staticClass: "amount_symbol"
  }, [_vm._v(" " + _vm._s(_vm.amount) + " "), _c('b', [_vm._v(_vm._s(_vm.symbol))])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }